{
  "title": "Não foi possível concluir seu check-in",
  "message": "Seu ID não pôde ser validado"
}
